import React from 'react';
import Footer from 'components/Footer.js';

import PopoverWrapper from 'components/popover/PopoverWrapper.js';
import HeaderBar from 'components/HeaderBar.js';
import TOSModal from 'components/TOSModal.js';
import ConfirmationModal from 'components/ConfirmationModal.js';
import FrozenModal from 'components/FrozenModal';
import AccountActions from 'actions/AccountActions.js';

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this._makeshiftLoginComplete = this._makeshiftLoginComplete.bind(this);
    this._coreAccountDataSuccess = this._coreAccountDataSuccess.bind(this);
    this._displayConfirmation = this._displayConfirmation.bind(this);
    this._acceptedTOS = this._acceptedTOS.bind(this);
    this._handleAppjsLogoutState = this._handleAppjsLogoutState.bind(this);
    this._authPollInterval = null;

    this.state = {
      user: Utils.getCoreUser() || {},
      confirm: false
    };
  }

  componentWillMount() {
    Utils.checkUserAuth();
  }

  componentDidMount() {
    LoginStore.on('login:success', this._makeshiftLoginComplete);
    AccountStore.on('account:logout', this._handleAppjsLogoutState);
    AccountStore.on('core:account:load:success', this._coreAccountDataSuccess);
    UserSettingsStore.on('user:settings:tos:accepted', this._acceptedTOS);
    Utils.setAppInstantiated(true);

    this._initSSOParams();
    this._initTokenChecks();
  }

  componentWillUnmount() {
    LoginStore.off('login:success', this._makeshiftLoginComplete);
    AccountStore.off('core:account:load:success', this._coreAccountDataSuccess);
    UserSettingsStore.off('user:settings:tos:accepted', this._acceptedTOS);
  }

  _initSSOParams() {
    const { query } = this.props.location;
    // Check for error url param from SSO redirect
    if (query.error) {
      const err = { responseText: query.error };
      LoginStore.trigger('login:error', err);
    }
    // Check for token url param from SSO redirect
    if (query.token) {
      this._makeshiftLoginComplete({
        authentication_token: query.token,
      });
      AccountActions.checkTokenValidity();
    }
  }

  _initTokenChecks() {
    setInterval(() => {
      const token = Utils.getAuthToken();
      // check if token exists
      if (!token) {
        if (this.state.user.id) {
          Utils.signOut();
          LoginStore.trigger('login:tokenDisappear');
        }
        return;
      }
      // check if token belongs to current user
      const user = Utils.getCoreUser() || {};
      if (user.id !== this.state.user.id) {
        if (!this.state.user.id) {
          // assume the user was in a logged out state prior
          // manually trigger signin flow with local storage variables
          LoginStore.trigger('login:success', {
            authentication_token: Utils.getAuthToken(),
          });
          AccountActions.getCoreAccount();
        } else {
          // assume a user is logged in with wrong account
          // this should happen rarely, just signout for security
          Utils.signOut();
        }
        return;
      }

      this.checkCycle = (this.checkCycle || 1) % 12;
      if (this.checkCycle === 1) {
        AccountActions.checkTokenValidity();
      }
      this.checkCycle += 1;
    }, 5000);
  }

  _handleAppjsLogoutState() {
    this.setState({
      user: {},
      frozenModalActive: false,
    });
  }

  _displayConfirmation() {
    this.setState({
      confirm: true
    });
  }

  _acceptedTOS(response) {
    const user = Utils.getCoreUser();
    user.tos.accepted_at = moment()
      .format();

    Utils.setCoreUser(user);
    this.setState({
      user: user,
    });
  }

  _makeshiftLoginComplete(token) {
    Utils.setAuthToken(token.authentication_token);
    AccountActions.getCoreAccount();
    this._redirectOnSuccessfulLoginRequest();
  }

  _validUserId(id) {
    // if previous user id is not a number no need to compare.
    if (isNaN(id)) {
      return false;
    }
    return parseInt(id, 10);
  }

  _isPreviousUserDifferent(previousID) {
    if (!previousID) return true;
    // does the current user id equal the previous user id?
    return previousID !== this._validUserId(Utils.getCoreUser().id);
  }

  _coreAccountDataSuccess(account) {
    Utils.setCoreUser(account);
    Utils.setLocale(account.push_settings.locale);
    this.setState({
      user: account,
      frozenModalActive: account.company.is_frozen,
    });
  }

  _redirectOnSuccessfulLoginRequest() {
    let location = '/schedule';
    if (Utils.getPreviousLocation() != '' && Utils.getPreviousLocation() != '/') {
      location = Utils.getPreviousLocation();
    }
    const bh = Utils.getBrowserHistory();
    bh.push(location);
  }

  _cleanUpLocationName(name) {
    switch (name) {
      case '/account':
      case '/timesheets':
        name = 'user-nav';
        break;
      case '/schedule':
        name = 'schedule';
        break;
    }
    return name;
  }

  _requiresTOSAcceptance() {
    let requiresTOSAcceptance = true;
    const user = (Utils.getCoreUser() || {});
    if (user.tos) {
      const { tos } = user;
      if (tos.accepted_at) {
        requiresTOSAcceptance = moment(tos.accepted_at) < moment(tos.last_updated_at);
      } else {
        requiresTOSAcceptance = true;
      }
    } else {
      requiresTOSAcceptance = false;
    }

    return requiresTOSAcceptance && !this.state.frozenModalActive;
  }

  render() {
    const location = this._cleanUpLocationName(Utils.getInitialLocation());
    const requiresTOSAcceptance = this._requiresTOSAcceptance();
    let className = 'box';
    if (requiresTOSAcceptance) {
      className += ' modal-open';
    }

    return (
      <div id="reactContainer">
        <FrozenModal
          active={this.state.frozenModalActive}
        />
        <TOSModal
          requiresTOSAcceptance={requiresTOSAcceptance}
        />
        <ConfirmationModal />
        <PopoverWrapper id="popOverContainer" className={className}>
          <HeaderBar currentLocation={location} userName={this.state.user.name}/>

          <div id="contentContainer">{this.props.children}</div>
          {window.location.pathname === '/' &&
            <Footer/>
          }
        </PopoverWrapper>
      </div>
    );
  }
}
